import { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import { MessageColorSchema } from 'components/ChatMessage/ChatMessage.types'
import { renderMarkdownAnchor, urlTransform } from 'components/Markdown'

import { TextMessageMarkdownWrapper } from './TextMessage.styles'

interface TextMessageProps {
  text: string
  colorSchema: MessageColorSchema
}

export const TextMessage: FC<TextMessageProps> = ({ text, colorSchema }) => {
  if (!text) {
    return null
  }

  return (
    <TextMessageMarkdownWrapper
      translate="yes"
      color={colorSchema.text}
      lineHeight="22px"
    >
      <ReactMarkdown
        allowedElements={['a', 'code', 'strong', 'em', 'ul', 'li']}
        unwrapDisallowed
        remarkPlugins={[remarkBreaks, remarkGfm]}
        transformLinkUri={urlTransform}
        components={{
          a: renderMarkdownAnchor,
        }}
      >
        {text.replace(/\n/gi, '\n &nbsp;')}
      </ReactMarkdown>
    </TextMessageMarkdownWrapper>
  )
}
